export default {
	title: 'Configuración de Cilindro',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa',
		requiredError: 'El campo obligatorio no puede estar vacío'
	},
	buttons: {
		add: 'Añadir',
		batchDelete: 'Eliminación por Lote',
		edit: 'Editar',
		delete: 'Eliminar'
	},
	table: {
		phaseAngle: 'Ángulo de Fase',
		cylinderNumber: 'Número de Cilindro',
		cylinderName: 'Nombre del Cilindro',
		diagnosisNumber: 'Número de Diagnóstico',
		deviceNumber: 'Número de Dispositivo',
		linkMass: 'Masa de Biela (kg)',
		intakePressure: 'Presión de Admisión (kPa)',
		outletPressure: 'Presión de Salida (kPa)',
		crankRadius: 'Radio de Cigüeñal',
		inertiaMass: 'Masa de Inercia (kg)',
		cylinderBoreDiameter: 'Diámetro del Cilindro',
		pistonRodDiameter: 'Diámetro del Vástago',
		linkLength: 'Longitud de Biela (m)',
		pistonArea: 'Área del Pistón',
		poleArea: 'Área del Vástago',
		action: 'Acción'
	},
	form: {
		placeholder: {
			projNo: 'Número de Diagnóstico',
			deviceNo: 'Número de Dispositivo',
			phaseAngle: 'Por favor ingrese',
			number: 'Por favor ingrese',
			linkMass: 'Por favor ingrese la masa de biela',
			intakePressure: 'Por favor ingrese la presión de admisión',
			outletPressure: 'Por favor ingrese la presión de salida',
			crankRadius: 'Por favor ingrese el radio de cigüeñal',
			inertiaMass: 'Por favor ingrese la masa de inercia',
			cylinderBoreDiameter: 'Por favor ingrese el diámetro del cilindro',
			pistonRodDiameter: 'Por favor ingrese el diámetro del vástago',
			linkLength: 'Por favor ingrese la longitud de biela',
			pistonArea: 'Por favor ingrese el área del pistón',
			poleArea: 'Por favor ingrese el área del vástago'
		},
		label: {
			phaseAngle: 'Ángulo de Fase',
			number: 'Número de Cilindro',
			projNo: 'Número de Diagnóstico',
			deviceNo: 'Número de Dispositivo',
			linkMass: 'Masa de Biela (kg)',
			intakePressure: 'Presión de Admisión (kPa)',
			outletPressure: 'Presión de Salida (kPa)',
			crankRadius: 'Radio de Cigüeñal',
			inertiaMass: 'Masa de Inercia (kg)',
			cylinderBoreDiameter: 'Diámetro del Cilindro',
			pistonRodDiameter: 'Diámetro del Vástago',
			linkLength: 'Longitud de Biela (m)',
			pistonArea: 'Área del Pistón',
			poleArea: 'Área del Vástago'
		}
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula'
	},
	dialog: {
		add: 'Añadir',
		update: 'Editar'
	}
}
